module.exports = function getResource(label) {
    const resources = {
        anErrorOccurredPleaseTryAgainLater: 'Une erreur s’est produite. Veuillez réessayer plus tard.',
        error: 'Erreur',
        ok: 'OK',
        passkeyAuthenticationErrorMessage: 'Une erreur s’est produite lors de l’ouverture de la session. Veuillez utiliser votre courriel et votre mot de passe pour vous connecter.',
        passkeyAccountDeactivatedMessage: 'To reactivate the account, please call our Customer Service team at 1-877-SEPHORA (1-877-737-4672) Or Chat with our agents.',
        passkeyFromYourAccount: 'clé d’accès de votre compte.',
        passkeyRemoved: 'Clé d’accès supprimée',
        pleaseConfirmYouWantToRemove: 'Voulez-vous vraiment supprimer?',
        removePasskey: 'Supprimer la clé d’accès',
        removePasskeysTitle: 'Supprimer la clé d’accès?',
        yourPasskeyHaveBeenRemoved: 'Votre clé d’accès a été supprimée.'
    };
    return resources[label];
};
